import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Agencia } from 'src/app/entidades/agencia';
import { AgenciaService } from 'src/app/services/agencia/agencia.service';
import { ApiService } from 'src/app/services/api/api.service';
import { MensagemService } from 'src/app/services/mensagem/mensagem.service';
import { PermissaoCotarService } from 'src/app/services/permissao-cotar/permissao-cotar.service';
import { DataFormModule } from 'src/app/shared/data-form.module';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-permissao-cotar',
  standalone: true,
  imports: [SharedModule, DataFormModule],
  templateUrl: './permissao-cotar.component.html',
  styleUrl: '../../app.component.css'
})
export class PermissaoCotarComponent {
  titulo: string = '';
  agencias: Agencia[] = [];
  formulario: FormGroup = new FormGroup({});
  agenciasFiltradas: Agencia[] = [];
  filtroCtrl = new FormControl();
  
  constructor(
    public dialogRef: MatDialogRef<PermissaoCotarComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private permissaoCotarService: PermissaoCotarService,
    private agenciaService: AgenciaService,
    private mensagemService: MensagemService,
    private formBuilder: FormBuilder,
    private apiService: ApiService
  ) {
    this.titulo = data.titulo;
  }

  async ngOnInit(): Promise<void> {
    this.criarFormulario();
    await this.obterAgencias();
  }

  async obterAgencias(): Promise<void> {
    await this.agenciaService.todas().then(res => {
      this.agencias = this.apiService.verificaSeResult<any[]>(res);
      this.agenciasFiltradas = this.agencias.slice();
    });
  }

  criarFormulario(): void {
    this.formulario = this.formBuilder.group({
      codPA: [null, Validators.required]
    });
  }

  async onSubmit(): Promise<void> {
    await this.permissaoCotarService.AddPermissao(this.formulario.value.codPA).then(async result => {
      if (!result) {
        await this.mensagemService.showMessage('Não foi possível adicionar a permissão.', 'Ok', 5000, 'error');
      } else {
        await this.mensagemService.showMessage('Permissão adicionada com sucesso.', 'Ok', 5000, 'success');
        this.fechar();
      }
    });
  }  

  fechar(): void {
    this.dialogRef.close('Yes');
  }
}
